define('drops/modalAction/modalAction',[
    'jquery',
    'lq/drop',
    'lq/modalblur',
    'drops/modals',
    './ModalActionMpa',
    './ModalActionSpa',
    'lq/style'
], function ($, Drop, ModalBlur, modals, ModalActionMpa, ModalActionSpa, Style) {
    'use strict';

    var minimumZIndexOfModalLayer = 6000;
    var minimumZIndexOfPopup = 6001;

    var defaults = {
        data: {
            size: { x: 200, y: 80 },
            actionId: '',
            parameters: [],
            eventsToCatch: [],
            lightBoxOpacity: 100,
            animation: 'none',
            minWidth: null,
            minHeight: null,
            useSelectedActionSize: true,
            actionSource: 'selectAction',
            renderInScrollContainer: false
        }
    };

    var ModalAction = function (options) {
        Drop.call(this, $('<div class="modal-action" />'), defaults, options);
        Style.renderStyles(this);
    };

    Drop.extend(ModalAction, Drop);

    ModalAction.typeName = 'ModalAction';

    ModalAction.prototype.preRender = function () {
        this.implementation = this.piping.application.singlePage
            ? new ModalActionSpa(this)
            : new ModalActionMpa(this);
        this.implementation.setUp();

        this.piping.visibility.apply(this);
        this.implementation.modalAction.data.useSelectedActionSize
            ? this.resetMinimumDimensions()
            : this.applyMinimumDimensions();
        this.applyPosition();
        this.applyZIndex();
        this.applyAnimation();
        if (this.data.renderInScrollContainer && this.data.centeredVertically) {
            this.$verticalCentering = $('<div class = "vertical-centering"/>')
                .css({
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    minHeight: '100%',
                    flexShrink: '0'
                });
            this.$element
                .css({
                    position: 'relative',
                    top: '0px'
                });
        }
    };

    ModalAction.prototype.setElementSizeBasedOnAnchoring = function (anchoringData, e) {
        if (anchoringData.top === null ||
            anchoringData.top === undefined ||
            anchoringData.bottom === null ||
            anchoringData.bottom === undefined) {
            this.$element.height(e.sizeY);
            if (this.implementation.modalAction.data.useSelectedActionSize)
                this.resetHeight(e.sizeY);
        }
        if (anchoringData.left === null ||
            anchoringData.left === undefined ||
            anchoringData.right === null ||
            anchoringData.right === undefined) {
            this.$element.width(e.sizeX);
            if (this.implementation.modalAction.data.useSelectedActionSize)
                this.resetWidth(e.sizeX);
        }
    };

    ModalAction.prototype.applyAnimation = function () {
        if (this.data.animation === 'zoomin') {
            this.$element.addClass('modal-animated-zoomin');
        }
    };

    ModalAction.prototype.applyMinimumDimensions = function () {
        if (this.data.minHeight) {
            this.$element.css('minHeight', this.data.minHeight + 'px');
        }

        if (this.data.minWidth) {
            this.$element.css('minWidth', this.data.minWidth + 'px');
        }
    };

    // In the MPA implementation we reset the size of those containers
    // to the scrollsize in every 300 milliseconds.
    // This is because the content of the ModalAction can shrink or expand.
    // BUT, if we jump to another action within the modal, we have to reset it
    // otherwise the biggest size will be applied
    ModalAction.prototype.resetHeight = function (height) {
        if (this.implementation && this.implementation.tryGetIframeContentDocument) {
            var contentDocument = this.implementation.tryGetIframeContentDocument();
            if (contentDocument) {
                var $theBody = $(contentDocument.body);
                if ($theBody) {
                    var $nestedLicquidContainer = $theBody.find('.licquid-action-wrapper');
                    if ($nestedLicquidContainer) {
                        $nestedLicquidContainer.css({
                            height: height ? (height + 'px') : '0px'
                        });
                    }
                }
            }
        }
    };

    ModalAction.prototype.resetWidth = function (width) {
        if (this.implementation && this.implementation.tryGetIframeContentDocument) {
            var contentDocument = this.implementation.tryGetIframeContentDocument();
            if (contentDocument) {
                var $theBody = $(contentDocument.body);
                if ($theBody) {
                    $theBody.css({
                        width: width ? (width + 'px') : '0px'
                    });
                }
            }
        }
    };

    ModalAction.prototype.resetMinimumDimensions = function () {
        this.$element.css({
            minHeight: '',
            minWidth: ''
        });
    };

    ModalAction.prototype.applyZIndex = function () {
        this.$element.css('zIndex', minimumZIndexOfPopup + this.data.zIndex);
    };

    ModalAction.prototype.postRender = function () {
        Drop.prototype.postRender.apply(this, arguments);
        this.renderModalLayer(this.data);

        if (this.isVisible()) {
            this.show();
        }

        if (!this.designData) {
            if (this.isScrollable()) {
                this.$scrollContainer
                    .css({
                        overflow: 'auto'
                    });

                if (this.data.renderInScrollContainer && this.data.centeredVertically) {
                    this.$verticalCentering.append(this.$element);
                    this.$scrollContainer.append(this.$verticalCentering);
                }
                else {
                    this.$scrollContainer.append(this.$element);
                }
            } else if (this.data.renderInScrollContainer) {
                this.$element
                    .appendTo(this.piping.$modals);
            }
        }
    };

    ModalAction.prototype.getHorizontalCenterPosition = function () {
        var totalWidth = $(window).width();
        return ((totalWidth - this.data.size.x) / 2) >= 0 ? (totalWidth - this.data.size.x) / 2 : 0;
    };

    ModalAction.prototype.getVerticalCenterPosition = function () {
        var totalHeight = $(window).height();
        return ((totalHeight - this.data.size.y) / 2) >= 0 ? (totalHeight - this.data.size.y) / 2 : 0;
    };

    ModalAction.prototype.show = function () {
        var actionId = this.getActionId()
        this.implementation.show(actionId);

        this.$element.addClass("open");

        Drop.prototype.show.call(this);

        if (this.$scrollContainer) {
            this.updateScrollContainerZIndex();
            this.$scrollContainer.show();
            if (this.data.renderInScrollContainer && this.data.centeredVertically) {
                this.$scrollContainer
                    .css({
                        display: 'flex',
                        flexDirection: 'column'
                    });
            }
        }
        ModalBlur.applyBlur.call(this);

        this.addBackgroundClickHandler();

    };

    ModalAction.prototype.afterHidden = function () {
        if (this.$modalLayer) {
            this.$modalLayer.addClass('closed');
            this.$modalLayer.hide();
        }
        if (this.$scrollContainer) {
            this.$scrollContainer.scrollTop(0);
            this.$scrollContainer.hide();
        }
        if (this.data.hasBlur) {
            ModalBlur.setBlurValue.call(this, 0);
        }
    };

    ModalAction.prototype.hide = function () {
        this.$element.removeClass("open");
        this.implementation.hide();
        this.removeBackgroundClickHandler();
        Drop.prototype.hide.call(this);
    };

    ModalAction.prototype.addBackgroundClickHandler = function () {
        this.removeBackgroundClickHandler();
        var self = this, openTime = Date.now();
        this.backgroundClickHandler = function (event) {
            // We setup this flag when the animation starts in Drop.js.
            // Once the animation starts we need to wait till it's finished.
            if (self.animationInProgress)
                return;
            if (Date.now() - openTime < 50 || self.$element[0] === event.target || $.contains(self.$element[0], event.target))
                return;

            // e.g. the invisible input element that is used to upload files
            if (!$(event.target).is(':visible'))
                return;

            self.removeBackgroundClickHandler();

            if (self.data.closeWhenBackgroundClicked && self.data.renderInScrollContainer)
                self.hide();
            self.triggerEventIfEnabled('backgroundClicked');
        };

        this.piping.$app.on('click touchstart', this.backgroundClickHandler);
    };

    ModalAction.prototype.removeBackgroundClickHandler = function () {
        if (this.backgroundClickHandler) {
            this.piping.$app.off('click touchstart', this.backgroundClickHandler);
            this.backgroundClickHandler = null;
        }
    };

    ModalAction.prototype.renderModalLayer = function () {
        var bgColor = 'rgba(0, 0, 0, 0)';
        if (this.data.hasLightBox && this.data.lightBoxColor) {
            var splited = this.data.lightBoxColor.split(',');
            var opac =  parseFloat(splited[3]) * this.data.lightBoxOpacity / 100;
            bgColor = splited[0] + ',' + splited[1] + ',' + splited[2] + ', ' + opac + ')';
        }

        if (this.data.renderInScrollContainer) {
            this.$scrollContainer = this.$scrollContainer || $('<div class = "scroll-container" />').hide();
            this.$scrollContainer
                .css({
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                    zIndex: 0,
                    overflowY: 'hidden',
                    backgroundColor: bgColor
                });

            if (this.isVisible()) {
                this.updateScrollContainerZIndex();
            }

            if (this.data.animation !== 'none') {
                this.$scrollContainer.addClass('modal-animated-modallayer closed');
            }

            if (this.data.toBrowser)
                this.$scrollContainer.appendTo(this.piping.$actionWrapper);
            else
                this.$scrollContainer.appendTo(this.piping.$modals);

            this.$scrollContainer.append(this.$element);
        }
    };

    ModalAction.prototype.updateScrollContainerZIndex = function () {
        if (this.piping.application.singlePage) {
            this.$scrollContainer.css('zIndex', modals.getNextZIndex());

            if (!this.designData && !this.isScrollable()) {
                this.$element.css('zIndex', modals.getNextZIndex());
            }
        } else {
            this.$scrollContainer.css('zIndex', minimumZIndexOfModalLayer + this.data.zIndex);

            if (this.$modalLayer) {
                this.$modalLayer.css('zIndex', minimumZIndexOfModalLayer + this.data.zIndex - 1);
            }
        }
    };

    ModalAction.prototype.getActionId = function () {
        if (this.data.actionSource === 'fromParameter')
            return this.piping.parameters.getValue(this.data.actionIdParameter);

        if (this.data.actionSource === 'selectAction')
            return this.data.actionId;

        if (this.data.actionSource === 'fromMapping')
            return this.mappedActionId;

        return undefined;
    };

    ModalAction.prototype.getParametersForIframe = function () {
        if (!this.data.parameters)
            return {};

        var self = this;
        var parametersForIframe = {};
        _.each(this.data.parameters, function (parameterName) {
            parametersForIframe[parameterName] = self.piping.parameters.getValue(parameterName);
        });

        return parametersForIframe;
    };

    ModalAction.prototype.triggerEventForChild = function (eventObj) {
        this.implementation.triggerEventForChild(eventObj);
    };

    ModalAction.prototype.isScrollable = function () {
        return this.data.renderInScrollContainer && this.$scrollContainer;
    };

    ModalAction.prototype.onError = function (errorArgs) {
        this.implementation.onError(errorArgs);
    };

    ModalAction.prototype.unsubscribeEventHandlers = function () {
        this.removeBackgroundClickHandler();
        ModalBlur.setBlurValue.call(this, 0);

        if (this.implementation)
            this.implementation.dispose();

        if (this.$scrollContainer)
            this.$scrollContainer.remove();
    };

    ModalAction.prototype.setValue = function (update) {
        if (update.value && this.data.actionSource === 'fromMapping') {
            this.mappedActionId = update.value;
            if(this.isVisible()) this.show();
        }
    };

    ModalAction.prototype.getDefaultEventArg = function () {
        return undefined;
    };

    ModalAction.prototype.showWithoutAnimation = function () {
        if (!this.designData) {
            return this.piping.viewTransitionManager.scheduleViewTransition(
                Drop.prototype.showWithoutAnimation.bind(this)
            );
        } else {
            Drop.prototype.showWithoutAnimation.call(this);
        }
    };

    ModalAction.prototype.hideWithoutAnimation = function () {
        if (!this.designData) {
            return this.piping.viewTransitionManager.scheduleViewTransition(
                Drop.prototype.hideWithoutAnimation.bind(this)
            );
        } else {
            Drop.prototype.hideWithoutAnimation.call(this);
        }
    };

    ModalAction.prototype.updateVisibilityFromParameter = function (drop) {
        if (this.valueFromParameterIsTrue(drop))
            drop.showWithoutAnimation();
        else
            drop.hideWithoutAnimation();
    };

    ModalAction.prototype.clearValue = $.noop;

    return ModalAction;
});

